// extracted by mini-css-extract-plugin
module.exports = {"formSection":"SupplierBasicFormFields_formSection__F8Fu1","sectionBody":"SupplierBasicFormFields_sectionBody__A2o1Z","marginBottom3":"SupplierBasicFormFields_marginBottom3__3u0di"};